// Components
import GuestNavbar from "../../Components/Guest/Components/GuestNavbar";

// Icons
import { Signpost, ArrowRight } from "phosphor-react";

// Other
import React from "react";
import { useState } from "react";
import { Link } from "react-router-dom";
import { supabase } from "../../client";

const Signup = () => {
  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    currency: "",
    password: "",
    mailing: "",
  });

  function handleChange(event) {
    setFormData((prevFormData) => {
      return {
        ...prevFormData,
        [event.target.name]: event.target.value,
      };
    });
  }

  const [validationData, setValidationData] = useState("");

  // Form Validation
  function validateForm(email, password, confirmPassword) {
    // Regular expression for checking if email is valid
    const emailRegex =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    // Regular expression for checking if password contains at least one uppercase letter and one special character
    const passwordRegex =
      /^(?=.*[A-Z])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{8,}$/;

    // Check if email is valid
    if (!emailRegex.test(email)) {
      return {
        isValid: false,
        error: "Please enter a valid email address.",
      };
    }

    // Check if password is at least 8 characters long and contains at least one uppercase letter and one special character
    if (!passwordRegex.test(password)) {
      return {
        isValid: false,
        error:
          "Password must be at least 8 characters long and contain at least one uppercase letter and one special character.",
      };
    }

    // Check if password and confirm password are equal
    if (password !== confirmPassword) {
      return {
        isValid: false,
        error: "Password and confirm password do not match.",
      };
    }

    // If all checks pass, form is valid
    return {
      isValid: true,
      error: "",
    };
  }

  async function handleSubmit(e) {
    e.preventDefault();

    setValidationData(
      validateForm(formData.email, formData.password, formData.confirmPassword)
    );

    // Validation Failed
    if (!validationData.isValid) {
      return;
    }

    setLoading(true);

    try {
      const { error } = await supabase.auth.signUp({
        email: formData.email,
        password: formData.password,
        options: {
          data: {
            first_name: formData.firstName,
            last_name: formData.lastName,
            currency: formData.currency,
          },
        },
      });

      if (error) throw error;
    } catch (error) {
      alert(error);
    }
  }

  return (
    <>
      <GuestNavbar />
      <section className="font-brand w-80 flex flex-col justify-center h-screen mobile:h-auto mobile:py-5">
        {loading ? (
          <section className="flex flex-col">
            <h1 className="text-xl font-bold mb-4 text-brand-500">
              Thank you for signing up!
            </h1>
            <p className="text-justify">
              A verification email has been sent to the email address you
              provided. Please check your email and follow the instructions to
              complete the verification process.
            </p>
          </section>
        ) : (
          <section>
            <section className="flex justify-between items-center">
              {/* Title */}
              <h1 className="flex items-center text-xl font-semibold">
                <Signpost size={25} color="#009fff" weight="bold" />
                <span className="ml-2">Sign Up</span>
              </h1>

              {/* Log in */}
              <span className="text-text-dark-500">
                <Link to="/login" className="underline font-medium">
                  Log in
                </Link>
                <span> instead.</span>
              </span>
            </section>
            {validationData.error ? (
              <span className="text-red-600 text-sm mt-2">
                {validationData.error}
              </span>
            ) : (
              ""
            )}

            {/* Sign up form */}
            <form onSubmit={handleSubmit} className="mt-5 space-y-3 > * + *">
              {/* Two inputs next to eachother */}

              <section className="flex justify-between">
                {/* First name */}
                <section>
                  <label
                    htmlFor="firstName"
                    className="block font-medium text-text-dark-500"
                  >
                    First name
                  </label>
                  <div className="relative mt-1 rounded-md shadow-sm">
                    <input
                      type="text"
                      name="firstName"
                      id="firstName"
                      className="block w-36 rounded-md pl-3 pr-12 sm:text-sm h-10 bg-dark-500 placeholder-text-dark-500"
                      placeholder="First name..."
                      onChange={handleChange}
                      required
                      autoComplete=""
                    />
                  </div>
                </section>

                {/* Last name */}
                <section>
                  <label
                    htmlFor="lastName"
                    className="block font-medium text-text-dark-500"
                  >
                    Last name
                  </label>
                  <div className="relative mt-1 rounded-md shadow-sm">
                    <input
                      type="text"
                      name="lastName"
                      id="lastName"
                      className="block w-36 rounded-md pl-3 pr-12 sm:text-sm h-10 bg-dark-500 placeholder-text-dark-500"
                      placeholder="Last name..."
                      onChange={handleChange}
                      required
                      autoComplete=""
                    />
                  </div>
                </section>
              </section>

              {/* Email */}
              <section>
                <label
                  htmlFor="email"
                  className="block font-medium text-text-dark-500"
                >
                  Email Address
                </label>
                <div className="relative mt-1 rounded-md shadow-sm">
                  <input
                    type="email"
                    name="email"
                    id="email"
                    className="block w-full rounded-md pl-3 pr-12 sm:text-sm h-10 bg-dark-500 placeholder-text-dark-500"
                    placeholder="you@example.com"
                    onChange={handleChange}
                    required
                    autoComplete=""
                  />
                </div>
              </section>

              {/* Currency */}
              <section>
                <label
                  htmlFor="currency"
                  className="block font-medium text-text-dark-500"
                >
                  Currency
                </label>
                <select
                  id="currency"
                  name="currency"
                  className="block w-full rounded-md pl-3 pr-12 sm:text-sm h-10 bg-dark-500 text-text-dark-700"
                  onChange={handleChange}
                  required
                  autoComplete=""
                >
                  <option className="text-text-dark-500" value="AUD">
                    $ — Australian dollar (AUD)
                  </option>
                  <option className="text-text-dark-500" value="BGN">
                    лв — Bulgarian lev (BGN)
                  </option>
                  <option className="text-text-dark-500" value="BRL">
                    R$ — Brazilian real (BRL)
                  </option>
                  <option className="text-text-dark-500" value="CAD">
                    $ — Canadian dollar (CAD)
                  </option>
                  <option className="text-text-dark-500" value="CHF">
                    CHF — Swiss franc (CHF)
                  </option>
                  <option className="text-text-dark-500" value="CNY">
                    ¥ — Chinese yuan (CNY)
                  </option>
                  <option className="text-text-dark-500" value="CZK">
                    Kč — Czech koruna (CZK)
                  </option>
                  <option className="text-text-dark-500" value="DKK">
                    kr — Danish krone (DKK)
                  </option>
                  <option className="text-text-dark-500" value="EUR">
                    € — Euro (EUR)
                  </option>
                  <option className="text-text-dark-500" value="GBP">
                    £ — British pound (GBP)
                  </option>
                  <option className="text-text-dark-500" value="HKD">
                    $ — Hong Kong dollar (HKD)
                  </option>
                  <option className="text-text-dark-500" value="HRK">
                    kn — Croatian kuna (HRK)
                  </option>
                  <option className="text-text-dark-500" value="HUF">
                    Ft — Hungarian forint (HUF)
                  </option>
                  <option className="text-text-dark-500" value="IDR">
                    Rp — Indonesian rupiah (IDR)
                  </option>
                  <option className="text-text-dark-500" value="ILS">
                    ₪ — Israeli shekel (ILS)
                  </option>
                  <option className="text-text-dark-500" value="INR">
                    ₹ — Indian rupee (INR)
                  </option>
                  <option className="text-text-dark-500" value="ISK">
                    kr — Icelandic króna (ISK)
                  </option>
                  <option className="text-text-dark-500" value="JPY">
                    ¥ — Japanese yen (JPY)
                  </option>
                  <option className="text-text-dark-500" value="KRW">
                    ₩ — South Korean won (KRW)
                  </option>
                  <option className="text-text-dark-500" value="MXN">
                    $ — Mexican peso (MXN)
                  </option>
                  <option className="text-text-dark-500" value="MYR">
                    RM — Malaysian ringgit (MYR)
                  </option>
                  <option className="text-text-dark-500" value="NOK">
                    kr — Norwegian krone (NOK)
                  </option>
                  <option className="text-text-dark-500" value="NZD">
                    $ — New Zealand dollar (NZD)
                  </option>
                  <option className="text-text-dark-500" value="PHP">
                    ₱ — Philippine peso (PHP)
                  </option>
                  <option className="text-text-dark-500" value="PLN">
                    zł — Polish złoty (PLN)
                  </option>
                  <option className="text-text-dark-500" value="RON">
                    lei — Romanian leu (RON)
                  </option>
                  <option className="text-text-dark-500" value="RUB">
                    ₽ — Russian ruble (RUB)
                  </option>
                  <option className="text-text-dark-500" value="SEK">
                    kr — Swedish krona (SEK)
                  </option>
                  <option className="text-text-dark-500" value="SGD">
                    $ — Singapore dollar (SGD)
                  </option>
                  <option className="text-text-dark-500" value="THB">
                    ฿ — Thai baht (THB)
                  </option>
                  <option className="text-text-dark-500" value="TRY">
                    ₺ — Turkish lira (TRY)
                  </option>
                  <option className="text-text-dark-500" value="USD">
                    $ — US dollar (USD)
                  </option>
                  <option className="text-text-dark-500" value="ZAR">
                    R — South African rand (ZAR)
                  </option>
                  <option className="text-text-dark-500" value="AED">
                    د.إ — United Arab Emirates dirham (AED)
                  </option>
                  <option className="text-text-dark-500" value="ARS">
                    $ — Argentine peso (ARS)
                  </option>
                  <option className="text-text-dark-500" value="BHD">
                    ب.د — Bahraini dinar (BHD)
                  </option>
                  <option className="text-text-dark-500" value="BND">
                    $ — Brunei dollar (BND)
                  </option>
                  <option className="text-text-dark-500" value="BOB">
                    Bs. — Bolivian boliviano (BOB)
                  </option>
                  <option className="text-text-dark-500" value="BWP">
                    P — Botswana pula (BWP)
                  </option>
                  <option className="text-text-dark-500" value="CLP">
                    $ — Chilean peso (CLP)
                  </option>
                  <option className="text-text-dark-500" value="COP">
                    $ — Colombian peso (COP)
                  </option>
                  <option className="text-text-dark-500" value="CRC">
                    ₡ — Costa Rican colón (CRC)
                  </option>
                  <option className="text-text-dark-500" value="EGP">
                    £ — Egyptian pound (EGP)
                  </option>
                  <option className="text-text-dark-500" value="FJD">
                    $ — Fijian dollar (FJD)
                  </option>
                  <option className="text-text-dark-500" value="GHS">
                    ₵ — Ghanaian cedi (GHS)
                  </option>
                  <option className="text-text-dark-500" value="GTQ">
                    Q — Guatemalan quetzal (GTQ)
                  </option>
                  <option className="text-text-dark-500" value="HNL">
                    L — Honduran lempira (HNL)
                  </option>
                  <option className="text-text-dark-500" value="HRK">
                    kn — Croatian kuna (HRK)
                  </option>
                  <option className="text-text-dark-500" value="HUF">
                    Ft — Hungarian forint (HUF)
                  </option>
                  <option className="text-text-dark-500" value="JMD">
                    J$ — Jamaican dollar (JMD)
                  </option>
                  <option className="text-text-dark-500" value="KES">
                    KSh — Kenyan shilling (KES)
                  </option>
                  <option className="text-text-dark-500" value="KWD">
                    د.ك — Kuwaiti dinar (KWD)
                  </option>
                  <option className="text-text-dark-500" value="LAK">
                    ₭ — Laotian kip (LAK)
                  </option>
                  <option className="text-text-dark-500" value="MAD">
                    MAD — Moroccan dirham (MAD)
                  </option>
                  <option className="text-text-dark-500" value="MDL">
                    L — Moldovan leu (MDL)
                  </option>
                  <option className="text-text-dark-500" value="MMK">
                    K — Burmese kyat (MMK)
                  </option>
                  <option className="text-text-dark-500" value="MUR">
                    ₨ — Mauritian rupee (MUR)
                  </option>
                  <option className="text-text-dark-500" value="NIO">
                    C$ — Nicaraguan córdoba (NIO)
                  </option>
                  <option className="text-text-dark-500" value="NPR">
                    ₨ — Nepalese rupee (NPR)
                  </option>
                  <option className="text-text-dark-500" value="OMR">
                    ر.ع. — Omani rial (OMR)
                  </option>
                  <option className="text-text-dark-500" value="PEN">
                    S/ — Peruvian nuevo sol (PEN)
                  </option>
                  <option className="text-text-dark-500" value="PGK">
                    K — Papua New Guinean kina (PGK)
                  </option>
                  <option className="text-text-dark-500" value="PKR">
                    ₨ — Pakistani rupee (PKR)
                  </option>
                  <option className="text-text-dark-500" value="PYG">
                    Gs — Paraguayan guaraní (PYG)
                  </option>
                  <option className="text-text-dark-500" value="QAR">
                    ر.ق — Qatari riyal (QAR)
                  </option>
                  <option className="text-text-dark-500" value="RSD">
                    дин — Serbian dinar (RSD)
                  </option>
                  <option className="text-text-dark-500" value="SAR">
                    ر.س — Saudi riyal (SAR)
                  </option>
                  <option className="text-text-dark-500" value="SCR">
                    ₨ — Seychellois rupee (SCR)
                  </option>
                  <option className="text-text-dark-500" value="SLL">
                    Le — Sierra Leonean leone (SLL)
                  </option>
                  <option className="text-text-dark-500" value="SVC">
                    ₡ — Salvadoran colón (SVC)
                  </option>
                  <option className="text-text-dark-500" value="TND">
                    د.ت — Tunisian dinar (TND)
                  </option>
                  <option className="text-text-dark-500" value="TWD">
                    $ — New Taiwan dollar (TWD)
                  </option>
                  <option className="text-text-dark-500" value="UAH">
                    ₴ — Ukrainian hryvnia (UAH)
                  </option>
                  <option className="text-text-dark-500" value="UYU">
                    $ — Uruguayan peso (UYU)
                  </option>
                  <option className="text-text-dark-500" value="VND">
                    ₫ — Vietnamese đồng (VND)
                  </option>
                  <option className="text-text-dark-500" value="VUV">
                    Vt — Vanuatu vatu (VUV)
                  </option>
                  <option className="text-text-dark-500" value="WST">
                    T — Samoan tala (WST)
                  </option>
                  <option className="text-text-dark-500" value="XAF">
                    FCFA — Central African CFA franc (XAF)
                  </option>
                  <option className="text-text-dark-500" value="XCD">
                    $ — East Caribbean dollar (XCD)
                  </option>
                  <option className="text-text-dark-500" value="XOF">
                    CFA — West African CFA franc (XOF)
                  </option>
                  <option className="text-text-dark-500" value="XPF">
                    F — French Pacific franc (XPF)
                  </option>
                  <option className="text-text-dark-500" value="YER">
                    ﷼ — Yemeni rial (YER)
                  </option>
                </select>
              </section>

              {/* Password */}
              <section>
                <label
                  htmlFor="password"
                  className="block font-medium text-text-dark-500"
                >
                  Password
                </label>
                <div className="relative mt-1 rounded-md shadow-sm">
                  <input
                    type="password"
                    name="password"
                    id="password"
                    className="block w-full rounded-md pl-3 pr-12 sm:text-sm h-10 bg-dark-500 placeholder-text-dark-500 text-white autofill:!bg-dark-500"
                    placeholder="Password..."
                    onChange={handleChange}
                    required
                    autoComplete=""
                    min="8"
                  />
                </div>
              </section>

              {/* Confirm Password */}
              <section>
                <label
                  htmlFor="confirmPassword"
                  className="block font-medium text-text-dark-500"
                >
                  Confirm Password
                </label>
                <div className="relative mt-1 rounded-md shadow-sm">
                  <input
                    type="password"
                    name="confirmPassword"
                    id="confirmPassword"
                    className="block w-full rounded-md pl-3 pr-12 sm:text-sm h-10 bg-dark-500 placeholder-text-dark-500 text-white"
                    placeholder="Re-enter Password..."
                    onChange={handleChange}
                    required
                  />
                </div>
              </section>

              {/* Checkboxes */}
              {/* Checkbox Terms */}
              <section className="form-check">
                <input
                  className="form-check-input appearance-none h-4 w-4 border border-gray-300 rounded-sm bg-white checked:bg-brand-500 checked:border-brand-500 focus:outline-none transition duration-200 mt-1 align-top bg-no-repeat bg-center bg-contain float-left mr-2 cursor-pointer"
                  type="checkbox"
                  value=""
                  id="terms"
                  required
                />
                <label
                  className="form-check-label flex text-text-dark-500"
                  htmlFor="terms"
                >
                  <span>
                    I have read and agreed to the{" "}
                    <Link to={"/terms"} className="text-brand-700">
                      Terms and conditions*
                    </Link>
                  </span>
                </label>
              </section>

              {/* Checkbox Mailing */}
              <section className="form-check">
                <input
                  className="form-check-input appearance-none h-4 w-4 border border-gray-300 rounded-sm bg-white checked:bg-brand-500 checked:border-brand-500 focus:outline-none transition duration-200 mt-1 align-top bg-no-repeat bg-center bg-contain float-left mr-2 cursor-pointer"
                  type="checkbox"
                  value=""
                  id="mailing"
                />
                <label
                  className="form-check-label flex text-text-dark-500"
                  htmlFor="mailing"
                >
                  I agree to receive information and commercial offers from
                  Mirelise
                </label>
              </section>

              {/* Submit Button */}
              <button className="flex py-1.5 px-4 rounded text-white bg-brand-500 hover:bg-brand-700 cursor-pointer">
                <span>Sign up</span>
                <ArrowRight
                  size={25}
                  color="#fff"
                  weight="bold"
                  className="ml-1"
                />
              </button>
            </form>
          </section>
        )}
      </section>
      {/* Header */}
    </>
  );
};

export default Signup;
